import { RouteMetadata } from './types';

export const metricsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/metrics/:metricId/events',
        section: 'metrics',
        view: 'events',
        descriptionTemplate: 'User is viewing events for metric {metricId}',
        capabilities: [
            'Inspect recent metric events',
            'Filter events by timeframe',
            'Review event payload details',
            'Identify anomalies and outliers',
        ],
        hints: [
            'Events represent captured metric records over time',
            'The daysBack query parameter controls the selected timeframe',
            'Event details help explain spikes and regressions',
        ],
    },
    {
        pattern: '/agents/:agentId/metrics/:metricId/schema',
        section: 'metrics',
        view: 'schema',
        descriptionTemplate: 'User is viewing schema details for metric {metricId}',
        capabilities: [
            'Inspect metric field definitions',
            'Review field types and semantic roles',
            'Understand dimensions and measures',
            'Assess schema evolution readiness',
        ],
        hints: [
            'Schema defines what fields are available for querying',
            'Field roles guide chart and aggregation options',
            'Well-typed schema improves dashboard quality',
        ],
    },
    {
        pattern: '/agents/:agentId/metrics/:metricId',
        section: 'metrics',
        view: 'overview',
        descriptionTemplate: 'User is viewing metric {metricId}',
        capabilities: [
            'Review metric health and usage at a glance',
            'Inspect recent trends and distributions',
            'Navigate to schema and events tabs',
            'Assess whether the metric is production-ready',
        ],
        hints: [
            'Overview summarizes quality, activity, and trend signals',
            'Use schema to validate field structure before building charts',
            'Use events to investigate abnormal behavior',
        ],
    },
    {
        pattern: '/agents/:agentId/metrics',
        section: 'metrics',
        view: 'list',
        descriptionTemplate: 'User is viewing the metrics list',
        capabilities: [
            'Browse available metrics',
            'Search metrics by name',
            'Filter metrics by status',
            'Open a metric details page',
        ],
        hints: [
            'Metrics are reusable datasets for analysis and dashboards',
            'Status filters are represented in URL search parameters',
            'Open a metric to inspect overview, schema, and events',
        ],
    },
];
